import { DEPLOY_ENV } from '../../globals';

/**
 * Saved-search UI is staging-only for now. Cosmos local/production auth is
 * currently broken, so we keep the create/switch/rename/delete surfaces off
 * the customer-facing `production` build and only expose them on staging (and
 * other non-prod environments) for testing.
 */
export const SAVED_SEARCHES_ENABLED = DEPLOY_ENV !== 'production';
